import React from 'react';

const BarChartRow = ({name, data, chartWidth, pxPerDay}) => {

  const durations = data.map(r => parseFloat(r.total));
  const colors    = data.map(r => r.color);
  const totalDays = durations.reduce((sum, d) => sum + d, 0);
  const formattedTotal = Number.isInteger(totalDays) ? totalDays : totalDays.toFixed(1);

  return (
    <div className={`chart-row ${name === "All Channels" ? "all-channels" : ""}`}>
      <div className="chart-label">{name}</div>

      <div className="bar-container" style={{ width: chartWidth }}>
        {durations.map((d, i) => {
          const rawPx   = d * pxPerDay;
          const widthPx = Math.max(rawPx, 6);
          return (
            <div
              key={i}
              className="bar-segment"
              style={{
                width: widthPx,
                backgroundColor: colors[i]
              }}
            >
              <span>{d}</span>
            </div>
          );
        })}
      </div>

      <div className="chart-total">
        {formattedTotal} days
      </div>
    </div>
  );
};

export default BarChartRow;